import { configUseFetch } from '@foodics/ui-common';
import { currentUserToken } from '@/composables/auth';
import { i18n } from '@/locales/config';

configUseFetch({
    baseUrl: `${import.meta.env.VITE_APP_URL}/api`,
    requestInterceptor,
    onError,
});

function requestInterceptor(config: RequestInit) {
    config.headers = {
        ...config.headers,
        lang: i18n.global.locale.value,
        ...(currentUserToken.value && {
            Authorization: `Bearer ${currentUserToken.value}`,
        }),
    };

    return config;
}

function onError(error: unknown) {
    if (!isUseFetchError(error)) return;
    if (error.cause.status !== 401) return;
    if (!currentUserToken.value) return;

    const isSessionExpired = error.body?.reason === 'SESSION_EXPIRED';

    currentUserToken.value = null;

    if (isSessionExpired) {
        sessionStorage.setItem('sessionExpired', 'true');
    }

    window.location.href = '/login';
}

type UseFetchError = { body: Record<string, unknown>; cause: Response };

export function isUseFetchError(error: unknown): error is UseFetchError {
    return (
        typeof error === 'object' &&
        error !== null &&
        'cause' in error &&
        error.cause instanceof Response
    );
}
